import React, { useState } from "react";

//import css
import "./Mid-Section-Pc.scss";

//import components
import InformationCardPc from "../../OverView/Pc-and-Large-Screens/Information-Card-Pc";
import TransactionsTable from "../../OverView/Pc-and-Large-Screens/Payments-Table";
import ProgressReportCard from "./Progress-Card";
import InvoicePendingTable from "./InvoicesPendingTable";

const MidSectionPaymentsPc = () => {
  const [tableToView, setTableToView] = useState("transactions");

  const cardData1 = {
    Title: "Invoices Paid",
    water: "5000",
    rent: "5000",
    arrears: "2000",
    garbage: "1000",
  };

  return (
    <div className="mid-section-payments-pc">
      <div className="title">
        Your Reports
        <div className="description">Invoice and payment information</div>
      </div>

      <div className="cards-container">
        <InformationCardPc
          Title={cardData1.Title}
          Ammount={"10,000"}
          setTableToView={setTableToView}
          valueToSet={"transactions"}
          // cardData={[cardData1.water, cardData1.rent, cardData1.arrears, cardData1.garbage]}
        />
        <InformationCardPc
          Title={"Invoices Pending"}
          setTableToView={setTableToView}
          valueToSet={"invoices"}
        />
        <InformationCardPc
          Title={"Pending approval"}
          Ammount={"5,000"}
          setTableToView={setTableToView}
          valueToSet={"transactions-pending"}
        />
        {/* <InformationCardPc Title={"Arrears"} setTableToView={setTableToView} />
        <InformationCardPc
          Title={"Other charges"}
          setTableToView={setTableToView}
        /> */}
      </div>
      <div className="transactions-and-progress">
        <div className="transactions-container">
          <div className="title">
            {tableToView === "transactions" && (
              <div className="description">This month's Transactions</div>
            )}
            {tableToView === "invoices" && (
              <div className="description">Pending Invoices</div>
            )}
          </div>

          <div className="transaction-history-table">
            {tableToView === "transactions" && <TransactionsTable />}
            {tableToView === "transactions-pending" && (
              <TransactionsTable pendingApproval={true} />
            )}
            {tableToView === "invoices" && <InvoicePendingTable />}
          </div>
        </div>
        <div className="progress-card-container">
          <ProgressReportCard />
        </div>
      </div>
    </div>
  );
};

export default MidSectionPaymentsPc;
